<script>
import { required, email } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import appConfig from "@/app.config";

import Layout from "@/router/layouts/auth";

export default {
  page: {
    title: "Khôi Phục Mật Khẩu",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      Email: "",
      submitted: false,
      error: null,
      tryingToReset: false,
      isResetError: false,
    };
  },
  methods: {
    // Try to register the user in with the email, fullname
    // and password they provided.
    tryToReset() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        this.$store.dispatch("auth/req_postForgot", {
          Email: this.Email,
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      errorMessage: "core/Error",
      successMessage: "core/Success",
    }),
  },
  validations: {
    Email: {
      required,
      email,
    },
  },
  mounted() {
    document.body.classList.add("auth-body-bg");
  },
};
</script>

<template>
  <Layout>
    <div class="w-100">
      <div class="d-flex flex-column h-100">
        <div class="mb-2 mb-md-3">
          <router-link to="/" class="d-block auth-logo">
            <img src="~@/assets/images/logo/logo-light-2.png" alt="" />
          </router-link>
        </div>
        <div class="my-4">
          <div>
            <h5 class="text-white fw-bold">Khôi phục mật khẩu</h5>
            <p class="text-white">
              Khôi phục mật khẩu của tài khoản PI Investment ngay bây giờ.
            </p>
          </div>

          <div class="mt-4">
            <!-- <div v-if="successMessage" class="alert-success alert">
              {{ successMessage }}
            </div>
            <div v-else-if="errorMessage" class="alert-danger alert">
              {{ errorMessage }}
            </div> -->
            <div class="alert alert-success text-center mb-4" role="alert">
              Nhập email của bạn chúng tôi sẽ gửi mail khôi phục mật khẩu cho
              bạn
            </div>
            <form @submit.prevent="tryToReset">
              <b-alert
                v-model="isResetError"
                class="mb-4"
                variant="danger"
                dismissible
                >{{ error }}</b-alert
              >
              <div class="mb-3">
                <label for="useremail">{{ $t("auth.email") }}</label>
                <b-form-input
                  id="email"
                  v-model="Email"
                  type="email"
                  :placeholder="$t('auth.enter-email')"
                  :class="{
                    'is-invalid': submitted && $v.Email.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.Email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.Email.required">
                    {{ $t("auth.required-email") }}
                  </span>
                  <span v-if="!$v.Email.email">
                    {{ $t("auth.required-email2") }}
                  </span>
                </div>
              </div>

              <div class="row mb-0">
                <div class="col-12 text-center">
                  <button
                    class="btn btn-primary w-md waves-effect waves-light"
                    type="submit"
                  >
                    Khôi Phục
                  </button>
                </div>
              </div>
            </form>
            <div class="mt-5 text-center">
              <p>
                Đã kích hoạt ?
                <router-link :to="{ name: 'login' }" class="fw-bold text-white">
                  Đăng Nhập Tại Đây
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
::v-deep .carousel-caption {
  position: relative !important;
  right: 0;
  left: 0;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #ffffff;
}

::v-deep .carousel-indicators li {
  background-color: rgba(85, 110, 230, 0.25);
}
</style>
